import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { fetchTranslationsAll } from './FetchData'; // Zde importuješ překlady
import { initLang } from './Config'; // Zde importuješ překlady
import { selectionTranslations } from './SelectionTranslations';
import { mediaTranslations } from './MediaTranslations';
import { textCompletionTranslations } from './TextCompletionTranslations';

const translations = await fetchTranslationsAll();

Object.entries(selectionTranslations).forEach(([code, selection]) => {
    translations[code] = { ...translations[code], selection, media: mediaTranslations[code], completion: textCompletionTranslations[code] };
});

i18n
  .use(initReactI18next)
  .init({
      resources: translations, // Přímo použij překlady jako resources
      lng: initLang,
      fallbackLng: initLang, 
      interpolation: {
          escapeValue: false // React už escapování provádí sám
      },
      debug: process.env.NODE_ENV !== 'production'
});

export default i18n;
